import React from "react";

export const TermsTextFr = (props) => {
  return (
    <div id="terms" className="text-center">
      <div className="containerInfo">
        <div className="section-title">
          <article className="arti">
            <h1 className="headerInfo">Conditions d’utilisation de ColorYou</h1>
            <p>
              En téléchargeant ou en utilisant l’app, vous acceptez ces
              Conditions. Merci de les lire attentivement avant d’utiliser
              l’app. Sur iOS, l’utilisation est également régie par le Apple
              Standard EULA disponible à{" "}
              <a
                href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.apple.com/legal/internet-services/itunes/dev/stdeula/
              </a>
              . Sur Android, l’utilisation est régie par les{" "}
              <a
                href="https://play.google.com/intl/fr/about/play-terms/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Conditions d’utilisation de Google Play
              </a>
              , y compris ses politiques d’achats et de remboursement{" "}
              <a
                href="https://support.google.com/googleplay/answer/2479637?hl=fr"
                target="_blank"
                rel="noopener noreferrer"
              >
                (politique de remboursement)
              </a>
              . Ces Conditions complètent ces accords.
            </p>

            <span className="sep"></span>
            <br />

            <h1 className="headerInfo2">
              1. Licence et propriété intellectuelle
            </h1>
            <p>
              Nous vous accordons une licence personnelle, non exclusive, non
              transférable et révocable pour utiliser l’app conformément à ces
              Conditions et au droit applicable. Vous ne pouvez pas copier ni
              modifier l’app ou l’une de ses parties, supprimer ou altérer des
              marques, tenter d’extraire le code source, décompiler, faire de
              l’ingénierie inverse, traduire ou créer des œuvres dérivées. L’app
              et tous les droits de propriété intellectuelle associés
              appartiennent à ColorYou ou à ses concédants.
            </p>

            <h1 className="headerInfo2">
              2. Modifications de l’app et éventuels frais
            </h1>
            <p>
              Nous nous efforçons de rendre l’app utile et efficace. Nous
              pouvons apporter des changements à l’app ou facturer certains
              services à tout moment. Nous ne vous facturerons jamais sans
              indiquer clairement l’objet et le prix sur l’écran d’achat de la
              boutique concernée.
            </p>

            <h1 className="headerInfo2">3. Achats intégrés</h1>
            <p>L’app propose deux options d’accès payant&nbsp;:</p>
            <ul>
              <li>
                a) <strong>Accès Premium 7 jours</strong>, accès de 7 jours sans
                renouvellement automatique qui déverrouille toutes les
                fonctionnalités premium.
              </li>
              <li>
                b) <strong>Accès Premium Illimité</strong>, achat unique qui
                déverrouille toutes les fonctionnalités premium, sans frais
                récurrents.
              </li>
            </ul>
            <p>
              Le prix s’affiche sur l’écran d’achat et peut varier selon le
              pays. Les achats sont traités par Apple ou Google. ColorYou n’a
              pas accès à vos données de paiement. Les remboursements sont gérés
              selon les politiques d’Apple ou de Google. Les achats sont liés à
              votre identifiant Apple ou à votre compte Google Play et peuvent
              être restaurés avec le même compte via l’option «&nbsp;Restaurer
              les achats&nbsp;». Nous ne proposons pas d’abonnements à
              renouvellement automatique. L’accès au contenu payant dépend de la
              disponibilité de l’app et du service. Les taxes et la facturation
              sont déterminées par Apple ou Google en fonction de votre pays de
              résidence. Toute contestation de facturation doit être traitée
              avec la boutique correspondante.
            </p>

            <h1 className="headerInfo2">4. Confidentialité et données</h1>
            <p>
              L’app peut stocker sur votre appareil (uniquement sur votre
              appareil) des données personnelles que vous fournissez pour
              fournir le service. Consultez la Politique de confidentialité pour
              savoir quelles données nous traitons, à quelles fins et vos
              droits&nbsp;:{" "}
              <a
                href="https://coloryou.app/#/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://coloryou.app/#/privacy
              </a>
              .
            </p>

            <h1 className="headerInfo2">5. Autorisations de l’appareil</h1>
            <p>
              L’app demande l’accès à des ressources protégées telles que
              l’appareil photo et la photothèque pour des fonctionnalités
              décrites dans l’app, par exemple prendre un selfie pour l’analyse
              colorimétrique ou photographier des tissus ou motifs à essayer. Si
              vous refusez des autorisations, certaines fonctionnalités peuvent
              ne pas être disponibles.
            </p>

            <h1 className="headerInfo2">6. Sécurité de l’appareil</h1>
            <p>
              Vous êtes responsable de la sécurité de votre téléphone et de
              l’accès à l’app. Nous déconseillons le jailbreak ou le root de
              l’appareil, car cela peut l’exposer à des logiciels malveillants,
              compromettre sa sécurité et affecter le bon fonctionnement de
              l’app.
            </p>

            <h1 className="headerInfo2">
              7. Connectivité et frais de l’opérateur
            </h1>
            <p>
              Certaines fonctionnalités requièrent une connexion Internet.
              ColorYou n’est pas responsable si l’app ne fonctionne pas
              pleinement en raison d’un manque de connectivité ou de limites de
              données. Si vous utilisez l’app sans Wi-Fi, votre opérateur peut
              appliquer des frais de données ou d’itinérance. En utilisant
              l’app, vous acceptez la responsabilité de ces frais.
            </p>

            <h1 className="headerInfo2">
              8. Disponibilité, mises à jour et compatibilité
            </h1>
            <p>
              L’app est disponible pour iOS et Android. Les exigences peuvent
              évoluer et vous pouvez avoir besoin d’installer des mises à jour
              pour continuer à l’utiliser. Nous ne garantissons pas que l’app
              restera toujours à jour ou compatible avec toutes les versions des
              systèmes. Nous pouvons cesser de proposer l’app ou en mettre fin à
              l’utilisation à tout moment. À la fin du service, les droits qui
              vous sont accordés cessent et vous devez arrêter d’utiliser l’app
              et, le cas échéant, la désinstaller.
            </p>

            <h1 className="headerInfo2">9. Limitation de responsabilité</h1>
            <p>
              Bien que nous nous efforcions de maintenir l’app à jour et exacte,
              nous dépendons d’informations de tiers. Dans la mesure permise par
              la loi, ColorYou n’est pas responsable des pertes directes ou
              indirectes résultant de l’utilisation de l’app, des interruptions
              de service, des changements de disponibilité ou des décisions
              prises sur la base des informations fournies par l’app.
            </p>

            <h1 className="headerInfo2">10. Services tiers</h1>
            <p>
              L’app peut intégrer des services tiers dont les conditions et
              politiques s’appliquent également, notamment&nbsp;:
            </p>
            <ul>
              <li>
                <a
                  href="https://www.revenuecat.com/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  RevenueCat
                </a>
              </li>
            </ul>

            <h1 className="headerInfo2">11. Résiliation</h1>
            <p>
              Nous pouvons suspendre ou résilier votre accès à l’app en cas de
              non-respect de ces Conditions ou pour des raisons opérationnelles.
              Sauf indication contraire, à la résiliation les droits et licences
              qui vous sont accordés cessent et vous devez cesser d’utiliser
              l’app.
            </p>

            <h1 className="headerInfo2">
              12. Modifications des présentes Conditions
            </h1>
            <p>
              Nous pouvons mettre à jour ces Conditions. Nous publierons sur
              cette page la version en vigueur et sa date d’effet. La poursuite
              de l’utilisation de l’app après les changements implique
              l’acceptation des nouvelles Conditions.
            </p>

            <h1 className="headerInfo2">13. Contact</h1>
            <p>
              Pour toute question ou suggestion concernant ces Conditions,
              écrivez à{" "}
              <span style={{ color: "#DD3D99" }}>coloryouapp@gmail.com</span>.
            </p>

            <span className="sep"></span>
            <br />

            <p>Date d’entrée en vigueur&nbsp;: 2025-09-08</p>
          </article>
        </div>
      </div>
    </div>
  );
};
